const grid = {
  left: 170,
  top: 0,
  right: 20,
  bottom: 40
  // containLabel: true,
};

export default grid;
